import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Collapse from 'antd/lib/collapse';
import EarlyRepaymentModal from '../../../features/loan-management/components/EarlyRepaymentModal';
import Form from 'antd/lib/form';
import Button from 'antd/lib/button';
import api from '../../../features/loan-management/api/index';
import {
  currencyFormatter,
  formatDate,
} from '../../../common/utils/helpers';

const CollapsePanel = Collapse.Panel;

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },

};

async function onEarlyRepaymentRequest(loan, status, rerenderPageFunc) { 
    api.setEarlyRepayment({loanId: loan.id, status: status})
    .then(loan.earlyRepayment = status, rerenderPageFunc());
}

const EarlyRepaymentCollapse = ({ visible, handleModalCancel, getEarlyRepaymentAmount, amount, rozdiel, amountNonPayedPrincipal,
  amountFee, penaltyFee ,nearestRepaymentDate, repaymentDate, earlyRepayLoan, tailFormItemLayout, showEarlyRepaymentModal, loan, rerenderPageFunc, earlyRepaymentRecord,t }) => (
  <Collapse>
    
        {earlyRepaymentRecord ? 

          <CollapsePanel header={t('Predčasné splatenie')}>
           <Form.Item {...formItemLayout} label={t('Dátum predčasného splatenia')}>
            <span>{formatDate(earlyRepaymentRecord.repaymentDate)}</span>
           </Form.Item>
 
            <Form.Item {...formItemLayout} label={t('Poplatok za predčasné splatenie')}>
              <span>{currencyFormatter(earlyRepaymentRecord.amount)}</span>
            </Form.Item>
          </CollapsePanel>
          :
          <CollapsePanel header={t('Predčasné splatenie')}>
             <Form.Item {...tailFormItemLayout}>
            <Button size="default" className="btn-inline" onClick={showEarlyRepaymentModal}>{t('Predčasné splatenie')}</Button>
            { !loan.earlyRepayment && 
              <Button size="default" className="btn-inline ant-btn-primary" onClick={() => onEarlyRepaymentRequest(loan, true, rerenderPageFunc)}>{t('Žiadosť o predčasné splatenie')}</Button>
            }
            { loan.earlyRepayment && 
              <Button size="default" className="btn-inline ant-btn-danger" onClick={() => onEarlyRepaymentRequest(loan, false, rerenderPageFunc)}>{t('Zrušit žiadosť o predčasné splatenie')}</Button>
            }
            <EarlyRepaymentModal
              visible={visible}
              handleModalCancel={handleModalCancel}
              getEarlyRepaymentAmount={getEarlyRepaymentAmount}
              amount={amount}
              rozdiel={rozdiel}
              amountNonPayedPrincipal={amountNonPayedPrincipal}
              amountFee={amountFee}
              penaltyFee={penaltyFee}
              nearestRepaymentDate={nearestRepaymentDate}
              repaymentDate={repaymentDate}
              earlyRepayLoan={(datetime) => earlyRepayLoan({loanId: loan.id, date: datetime})}
            ></EarlyRepaymentModal>
            </Form.Item>
          </CollapsePanel>
         
          } 
  </Collapse>
);

EarlyRepaymentCollapse.propTypes = {
  t: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  handleModalCancel: PropTypes.func.isRequired,
  getEarlyRepaymentAmount: PropTypes.func.isRequired,
  amount: PropTypes.number,
  rozdiel: PropTypes.number,
  amountNonPayedPrincipal: PropTypes.number,
  amountFee: PropTypes.number,
  penaltyFee: PropTypes.number,
  nearestRepaymentDate: PropTypes.date,
  repaymentDate: PropTypes.string,
  earlyRepayLoan: PropTypes.func.isRequired,
  showEarlyRepaymentModal: PropTypes.bool.isRequired,
  rerenderPageFunc: PropTypes.func.isRequired,
  loan: PropTypes.object.isRequired,
  earlyRepaymentRecord: PropTypes.object,
};

export default translate()(EarlyRepaymentCollapse);



// WEBPACK FOOTER //
// ./src/common/components/data-display/EarlyRepaymentCollapse.js